import { render, staticRenderFns } from "./DailyUpdate.vue?vue&type=template&id=4208cf52&scoped=true"
import script from "./DailyUpdate.vue?vue&type=script&lang=js"
export * from "./DailyUpdate.vue?vue&type=script&lang=js"
import style0 from "./DailyUpdate.vue?vue&type=style&index=0&id=4208cf52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208cf52",
  null
  
)

export default component.exports